var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-402.000000, -142.000000)",
    fill: "#01AE8F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(402.000000, 142.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.125,-1.77635684e-15 C14.1645983,-1.77635684e-15 18.25,4.08540166 18.25,9.125 C18.25,14.1645983 14.1645983,18.25 9.125,18.25 C4.08540166,18.25 -1.77635684e-15,14.1645983 -1.77635684e-15,9.125 C-1.77635684e-15,4.08540166 4.08540166,-1.77635684e-15 9.125,-1.77635684e-15 Z M9.125,1 C4.63768641,1 1,4.63768641 1,9.125 C1,13.6123136 4.63768641,17.25 9.125,17.25 C13.6123136,17.25 17.25,13.6123136 17.25,9.125 C17.25,4.63768641 13.6123136,1 9.125,1 Z M9.125,4.5 C9.37045989,4.5 9.57460837,4.67687516 9.61694433,4.91012437 L9.625,5 L9.62555981,7.5785558 C10.2780859,7.78961441 10.75,8.40219649 10.75,9.125 C10.75,9.39159686 10.6858004,9.6431991 10.5720178,9.86519007 L13.9785176,13.2714108 C14.1737995,13.4666532 14.1738315,13.7832357 13.9785892,13.9785176 C13.8050404,14.1521015 13.5356179,14.1714139 13.3407361,14.0364376 L13.2714824,13.9785892 L9.86418991,10.57253 C9.64244351,10.685993 9.39119657,10.75 9.125,10.75 C8.22753728,10.75 7.5,10.0224627 7.5,9.125 C7.5,8.40183033 7.97239232,7.78899379 8.62543201,7.57823535 L8.625,5 C8.625,4.72385763 8.84885763,4.5 9.125,4.5 Z M9.125,8.5 C8.77982203,8.5 8.5,8.77982203 8.5,9.125 C8.5,9.47017797 8.77982203,9.75 9.125,9.75 C9.289101,9.75 9.43843061,9.68675616 9.54994455,9.58331276 C9.55316354,9.57624036 9.55858249,9.57056186 9.56416084,9.56498238 L9.58233875,9.55099216 C9.68635903,9.4393667 9.75,9.28961542 9.75,9.125 C9.75,8.77982203 9.47017797,8.5 9.125,8.5 Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.6aa6df3b.svg";
export { ForwardRef as ReactComponent };